module.exports = {"513223100":"凤仪镇","513223101":"南新镇","513223102":"叠溪镇","513223103":"光明镇","513223104":"雅都镇","513223105":"富顺镇","513223201":"渭门乡","513223202":"永和乡","513223203":"沟口乡","513223206":"土门乡","513223207":"东兴乡","513223208":"黑虎乡","513223209":"飞虹乡","513223210":"回龙乡","513223211":"三龙乡","513223212":"白溪乡","513223213":"洼底乡","513223214":"石大关乡","513223215":"太平乡","513223216":"松坪沟乡","513223217":"曲谷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513223.json
// module id = 2215
// module chunks = 0